import { Product } from 'teacher-ui-client/utils/products'

export const MathseedsPrimeThread = {
  Number: 'number',
  Fractions: 'fractions',
  Operations: 'operations',
  Geometry: 'geometry',
  Measurement: 'measurement',
} as const

export type MathseedsPrimeThread = (typeof MathseedsPrimeThread)[keyof typeof MathseedsPrimeThread]

const MATHSEEDS_PRIME_THREAD_IDS = Object.values(MathseedsPrimeThread) as string[]

export const isMathseedsPrimeThread = (value: string): value is MathseedsPrimeThread =>
  MATHSEEDS_PRIME_THREAD_IDS.includes(value)

export function getProgressionSequenceUrlForProduct(product: Product): string | undefined {
  switch (product) {
    case Product.MSP:
      return 'https://api.mathseedsprime.com/progression.json'
    default:
      return undefined
  }
}
